import React from "react"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import AddCircle from "@mui/icons-material/AddCircle"
import WatchLaterIcon from "@mui/icons-material/WatchLater"
import ErrorIcon from "@mui/icons-material/Error"

import {theme} from "@indebted/theme"

function TransactionIcon({type}: {type: string}) {
	const map: Record<string, JSX.Element | undefined> = {
		PaymentSubmitted: (
			<WatchLaterIcon fontSize="small" style={{color: theme.palette.grey.A200, marginRight: theme.spacing(2)}} />
		),
		PaymentFailed: (
			<ErrorIcon fontSize="small" style={{color: theme.palette.error.light, marginRight: theme.spacing(2)}} />
		),
		PaymentSucceeded: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		PaymentPlanChargeSubmitted: (
			<WatchLaterIcon fontSize="small" style={{color: theme.palette.grey.A200, marginRight: theme.spacing(2)}} />
		),
		PaymentPlanChargeSucceeded: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		PaymentPlanChargeFailed: (
			<ErrorIcon fontSize="small" style={{color: theme.palette.error.light, marginRight: theme.spacing(2)}} />
		),
		PaymentPlanSettlementSubmitted: (
			<WatchLaterIcon fontSize="small" style={{color: theme.palette.grey.A200, marginRight: theme.spacing(2)}} />
		),
		PaymentPlanSettlementSucceeded: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		PaymentPlanSettlementFailed: (
			<ErrorIcon fontSize="small" style={{color: theme.palette.error.light, marginRight: theme.spacing(2)}} />
		),
		PaymentPlanDiscountApplied: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountChargebackReceivedThroughClient: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountChargedByClient: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountCompensatedByClient: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountWriteOffApplied: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountReinstatementApplied: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountLostDisputeApplied: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountRefundApplied: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountPaymentReceivedThroughClient: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountPaymentWithTaxReceivedThroughClient: (
			<CheckCircleIcon
				fontSize="small"
				style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}}
			/>
		),
		AccountCreated: (
			<AddCircle fontSize="small" style={{color: theme.palette.success.light, marginRight: theme.spacing(2)}} />
		),
	}

	return map[type] || null
}

export {TransactionIcon}
